import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { elegirFormatoNota, agregarPieNota, domicilioCliente, agregarAvisoPendienteFacturar, pendienteDeFacturar, rotuloCopia, firmaConfirmacionPedido } from "../../../../utils/formatoNota";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import { abrirPDF } from "../../../../utils/abrirPDF";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);

  // Guía de embarque (una hoja por paquete)
  const [modalGuia, setModalGuia] = useState(false);
  const toggleGuia = () => setModalGuia(!modalGuia);
  const [guia, setGuia] = useState(null);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_SURTIDOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido < b.idSurtido ? 1 : -1))
          .map((a) => {
            if(a.fecha >= "2023-04-24"){
            const usr = a.user && a.user[0] ? a.user[0] : null;
            const pedCli = a.pedidosCliente && a.pedidosCliente[0] ? a.pedidosCliente[0] : null;
            const cli = a.clientes && a.clientes[0] ? a.clientes[0] : null;
            const ped = a.pedidos && a.pedidos[0] ? a.pedidos[0] : null;
            // Todos los vendedores del pedido (o del surtido si el pedido no los trae)
            const listaVend =
              (ped && ped.colaboradores && ped.colaboradores.length
                ? ped.colaboradores
                : a.colaboradores) || [];
            return {
              _id: a._id,
              is_active:a.is_active,
              fecha: a.fecha,
              user: usr ? (usr.nombre + " " + usr.apellido) : "",
              idUser: usr ? usr._id : "",
              idPedidosCliente: pedCli ? pedCli.idPedido : "",
              pedidoCliente: pedCli ? pedCli.pedidoCliente : "NA",
              clientes: cli ? cli.nombre_comercial : "",
              codigo: cli ? cli.codigo : "",
              idClientes: cli ? cli._id : "",
              observaciones: a.observaciones,
              numero: a.idSurtido,
              impuestos: a.impuestos,
              subTotal: a.subTotal,
              iva: a.iva,
              seguro: a.seguro || 0,
              porcSeguro: a.porcSeguro || 0,
              pagoTarjeta: a.pagoTarjeta || "No",
              ivaIncluido: a.ivaIncluido || "No",
              comisionTarjeta: a.comisionTarjeta || 0,
              total_general: a.total_general,
              RFC: cli ? cli.RFC : "",
              vendedor: listaVend
                .map((v) => `${v.nombre} ${v.apellido || ""}`.trim())
                .join(", "),
              plazo: cli ? cli.plazo : "",
              recibida: a.recibida,
              numeroFactura: a.numeroFactura
            }
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setSurtidos(allSurtidos);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let totalImportePDF = 0;
  let subTotalPDF = 0;
  let totalIVAPDF = 0;

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = totalImportePDF + a.total_general;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.numero,
          a.numeroFactura,
          a.fecha,
          a.clientes,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
          a.user,
        ]
      }else {
        return [
          a.numero,
          a.numeroFactura,
          a.fecha,
          a.clientes,
          "",
          "Cancelada",
          "",
          a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["No.", "Factura", "Fecha", "Cliente", "SubTotal", "IVA", "Total", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImportePDF),

        ]
      ]
    });
    abrirPDF(doc);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        return {
          Numero: a.numero,
          Factura: a.numeroFactura,
          Fecha: a.fecha,
          Cliente: a.clientes,
          SubTotal: a.subTotal,
          IVA: a.iva,
          Total: a.total_general,
          Surtio: a.user,
        }
        }else{
          return {
            Numero: a.numero,
            Factura: a.numeroFactura,
            Fecha: a.fecha,
            Cliente: a.clientes,
            SubTotal: 0,
            IVA: 0,
            Total: 0,
            Surtio: a.user,
          }
        }
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: ["Numero", "Factura", "Fecha", "Cliente", "SubTotal", "IVA", "Total", "Surtio"],
        sheetHeader: ["Numero", "Factura", "Fecha", "Cliente", "SubTotal", "IVA", "Total", "Surtio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [a.numero, a.numeroFactura, a.fecha, a.clientes, a.pedidos, a.subTotal, a.iva, a.total_general, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Factura", "Fecha", "Cliente", "Pedido", "SubTotal", "IVA", "Total", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function cancelarNota(idNota) {
    if (!user.ventas_cancelar) {
      Swal.fire({ icon: "warning", title: "Sin permiso", text: "Solo los usuarios autorizados pueden cancelar." });
      return;
    }
    Swal.fire({
      title: "¿Cancelar la nota?",
      text: "Se regresa el inventario, se quita el cargo al cliente y se cancela el pedido. Si la nota tiene abonos no se podrá cancelar.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Listo", "Nota cancelada", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        const d = error.response && error.response.data;
        Swal.fire({
          icon: "warning",
          title: "No se pudo cancelar",
          text: (d && d.message) || (typeof d === "string" ? d : "Intenta de nuevo"),
        });
        console.log(error);
      });
    }
  });
  }

  // ===== Guía de embarque =====
  // Remitente fijo (como en la guía impresa que usan hoy)
  const GUIA_REMITENTE = [
    "MESONES # 121 1ER PISO COL. CENTRO D.F. C.P. 06090",
    "TEL. 55-22-21-27  FAX 5542-41-84 5522-93-46",
  ];
  const limpio = (v) => {
    const t = (v == null ? "" : String(v)).trim();
    return t && t.toUpperCase() !== "NA" ? t : "";
  };

  // Captura (o corrige) el número de factura de una venta con IVA
  // Número de factura en la tabla: resaltado si ya se capturó; "Sin factura" si sigue en "No"
  const celdaFactura = (nf) =>
    nf && nf !== "No" ? (
      <span style={{ fontWeight: 700, color: "#1d4ed8" }}>{nf}</span>
    ) : (
      <span style={{ color: "#9ca3af", fontSize: 12 }}>Sin factura</span>
    );

  async function capturarFactura(a) {
    const actual = a.numeroFactura && a.numeroFactura !== "No" ? a.numeroFactura : "";
    const r = await Swal.fire({
      title: `Factura de la venta #${a.numero}`,
      text: `${a.clientes || ""}`,
      input: "text",
      inputValue: actual,
      inputPlaceholder: "Número / folio de factura",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      inputValidator: (v) => (!v || !v.trim() ? "Captura el número de factura" : undefined),
    });
    if (!r.isConfirmed) return;
    const numeroFactura = r.value.trim();
    try {
      await axios.patch(
        `${URL_SURTIDOS}/${a._id}`,
        { numeroFactura },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      axios
        .post(
          process.env.REACT_APP_URL_LOGS,
          { tipo: "Numero de Factura", detalle: `Venta ${a.numero}: ${numeroFactura}`, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        )
        .catch(() => {});
      setComments((prev) => prev.map((x) => (x._id === a._id ? { ...x, numeroFactura } : x)));
      Swal.fire({ icon: "success", title: "Factura guardada", text: `Venta #${a.numero}: ${numeroFactura}`, timer: 1500, showConfirmButton: false });
    } catch (e) {
      const d = e.response && e.response.data;
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: (d && d.message) || "Error" });
    }
  }

  async function abrirGuia(a) {
    let cli = {};
    try {
      const r = await axios.get(`${URL_CLIENTES}/${a.idClientes}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      cli = r.data || {};
    } catch (e) {
      console.log(e);
    }
    const ext = limpio(cli.numero_ext);
    const int = limpio(cli.numero_int);
    const direccion = [limpio(cli.calle), ext ? `#${ext}` : "", int ? `INT ${int}` : ""]
      .filter(Boolean)
      .join(" ");
    const cp = limpio(cli.cp);
    const poblacion = [limpio(cli.ciudad) || limpio(cli.delegacion), limpio(cli.estado)]
      .filter(Boolean)
      .join(", ") + (cp ? ` C.P. ${cp}` : "");
    setGuia({
      numero: a.numero,
      fecha: a.fecha,
      codigoCliente: a.codigo || limpio(cli.codigo),
      vendedor: a.vendedor || "",
      nombre: limpio(cli.nombre_comercial) || a.clientes || "",
      sucursal: "",
      direccion,
      colonia: limpio(cli.colonia),
      poblacion,
      telefono: limpio(cli.telefono) || limpio(cli.celular) || limpio(cli.whatsapp),
      transporte: "",
      contenido: "ROPA P/DAMA",
      valor: Number(a.total_general) || 0,
      paquetes: 1,
    });
    setModalGuia(true);
  }

  function generarGuia() {
    if (!guia) return;
    const n = Math.max(1, parseInt(guia.paquetes, 10) || 1);
    // Hoja CARTA vertical con la guía en MEDIA CARTA (21.6 x 14 cm): 2 guías por hoja (arriba y
    // abajo) con línea punteada para cortar. Así sale a su tamaño aunque la impresora tenga carta.
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "letter" });
    const MEDIA = 139.7; // alto de media carta en mm
    const valor = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format(Number(guia.valor) || 0);
    for (let i = 1; i <= n; i++) {
      const mitad = (i - 1) % 2; // 0 = arriba, 1 = abajo
      if (i > 1 && mitad === 0) doc.addPage();
      const y0 = mitad * MEDIA;
      if (mitad === 0) {
        // Línea de corte a la mitad de la hoja
        doc.setLineDashPattern([2, 2], 0);
        doc.setDrawColor(150);
        doc.line(5, MEDIA, 210.9, MEDIA);
        doc.setLineDashPattern([], 0);
        doc.setDrawColor(0);
      }
      doc.setFont("courier", "normal");
      doc.setFontSize(10);
      doc.text(GUIA_REMITENTE[0], 108, y0 + 12, { align: "center" });
      doc.text(GUIA_REMITENTE[1], 108, y0 + 17, { align: "center" });
      doc.setFont("courier", "bold");
      doc.setFontSize(16);
      doc.text("DESTINATARIO:", 12, y0 + 30);

      const campos = [
        ["Nombre", guia.nombre, 15],
        ["Sucursal", guia.sucursal, 12],
        ["Direccion", guia.direccion, 12],
        ["Colonia", guia.colonia, 12],
        ["Poblacion", guia.poblacion, 12],
        ["Telefono", guia.telefono, 12],
        ["Transporte", guia.transporte, 12],
        ["Contenido", guia.contenido, 12],
        ["Valor", `$ ${valor}`, 12],
        ["Paquetes", `${i}/${n}`, 14],
      ];
      let y = y0 + 40;
      campos.forEach(([etq, val, size]) => {
        doc.setFont("courier", "normal");
        doc.setFontSize(11);
        doc.text(`${etq.padEnd(10)} :`, 12, y);
        doc.setFont("courier", "bold");
        doc.setFontSize(size);
        const lineas = doc.splitTextToSize(String(val || "").toUpperCase(), 150);
        doc.text(lineas, 52, y);
        y += 8 + (lineas.length - 1) * (size * 0.45);
      });

      // Lo que hoy anotan a mano: cliente / nota / vendedor y fecha
      doc.setFont("courier", "normal");
      doc.setFontSize(10);
      doc.line(12, y0 + 128, 204, y0 + 128);
      doc.text(
        `Cliente ${guia.codigoCliente || "-"}  |  Nota ${guia.numero}  |  ${guia.vendedor || "-"}  |  ${guia.fecha || ""}`,
        12,
        y0 + 134
      );
    }
    abrirPDF(doc);
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    impuestos,
    subTotal,
    iva,
    total_general,
    plazo,
    numeroFactura,
    vendedor,
    seguro,
    pagoTarjeta,
    comisionTarjeta,
    porcSeguro,
    ivaIncluido
  ) {
    // Con tarjeta o con IVA incluido en el precio, los renglones se muestran sin IVA (desglosado abajo)
    const divIva = pagoTarjeta === "Si" || ivaIncluido === "Si" ? 1.16 : 1;
    // Dos formatos: con política de cambios, o pagaré (sin devoluciones)
    const formato = await elegirFormatoNota();
    if (!formato) return;
    // La pestaña se abre YA (todavía con el clic del usuario) para que el navegador no la
    // bloquee como popup; cuando el PDF está listo se carga ahí.
    const ventana = window.open("", "_blank");
    if (ventana) ventana.document.write("<p style='font-family:sans-serif;padding:20px'>Generando pedido…</p>");
    let domicilio = "";
    if (formato === "pagare" && idClientes) {
      try {
        const rc = await axios.get(`${URL_CLIENTES}/${idClientes}`, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
        domicilio = domicilioCliente(rc.data);
      } catch (e) {
        domicilio = "";
      }
    }
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            // Precio/descuento: pedido normal usa articulosPedidoCliente;
            // venta directa usa articulosPedido.
            const ap =
              a.articulosPedidoCliente && a.articulosPedidoCliente[0]
                ? a.articulosPedidoCliente[0]
                : a.articulosPedido && a.articulosPedido[0]
                ? a.articulosPedido[0]
                : null;
            // Con tarjeta el precio de lista trae IVA: en la nota va sin IVA (desglosado abajo)
            const precio = (ap ? parseFloat(ap.precio) || 0 : 0) / divIva;
            // Precio especial autorizado con clave: se muestra "(precio de lista) precio dado"
            const precioLista =
              ap && ap.precioEspecial === "Si" ? (parseFloat(ap.precioLista) || 0) / divIva : 0;
            const descuento = ap ? parseFloat(ap.descuento) || 0 : 0;
            const art = a.articulos && a.articulos[0] ? a.articulos[0] : null;
            const col = a.colores && a.colores[0] ? a.colores[0] : null;
            const tal = a.tallas && a.tallas[0] ? a.tallas[0] : null;
            return {
              id: a._id,
              articulos: art ? `${art.codigo || ""} ${art.descripcion || ""}`.trim() : "",
              colores: col ? col.name : "",
              tallas: tal ? tal.name : "",
              cantidad: a.cantidad,
              idArticulo: art ? art._id : "",
              idColor: col ? col._id : "",
              precio: precio,
              precioLista,
              descuento: descuento,
              total: (parseFloat(a.cantidad) * precio - (parseFloat(a.cantidad) * precio * descuento) / 100).toFixed(2),
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // PDF: un renglón por ARTÍCULO (sin desglose de color/talla), sumando piezas e importe.
        // Mismo artículo a distinto precio/descuento sale en renglones separados.
        const porArticulo = new Map();
        dataFinal.forEach((a) => {
          const k = `${a.idArticulo}|${a.precio}|${a.descuento}`;
          const g = porArticulo.get(k) || { articulos: a.articulos, precio: a.precio, precioLista: a.precioLista, descuento: a.descuento, cantidad: 0, total: 0 };
          g.cantidad += parseFloat(a.cantidad) || 0;
          g.total += parseFloat(a.total) || 0;
          porArticulo.set(k, g);
        });
        const data = [...porArticulo.values()].map((a) => {
          return [
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            (a.precioLista > a.precio
              ? "(" + new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioLista) + ") "
              : "") +
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio),
            new Intl.NumberFormat("en-US").format(a.descuento) + "%",
            new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF();
        // 2 hojas: ORIGINAL para el cliente (con su formato) y COPIA (pedido pendiente de facturar, sin pagaré)
        const dibujar = (esCopia) => {
        rotuloCopia(doc, esCopia);
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 150, 10, 35, 10);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 80, 10, 30, 12);
        // Se presenta como PEDIDO (pendiente de facturar hasta que el cliente lo confirme)
        doc.setFont(undefined, "bold");
        doc.setFontSize(15);
        doc.text("PEDIDO", 15, 15);
        doc.setFontSize(11);
        doc.text(`No. ${numero}`, 15, 21);
        doc.setFont(undefined, "normal");

        doc.setFontSize(10);
        doc.text(`Domicilio: Mesones #121 1er piso esq. Pino Suárez, Col. Centro, CP 06090,`, 20, 25);
        doc.text(`Ciudad de México, México.  Tel. 55 5524 1844`, 20, 30);
        doc.setFontSize(10);
        
        doc.text(`Cliente ${clientes}`, 15, 40);
        doc.text(`Plazo ${plazo} días`, 15, 45);
        doc.text(`Factura ${numeroFactura}`, 15, 50);
        doc.text(`Vendedor(es): ${vendedor || ""}`, 15, 55);

        doc.text(`Fecha ${fecha}`, 110, 40);
        doc.text(`Pedido # ${numero}`, 110, 45);
        doc.text(`Forma de pago: Pago en una sola exhibición`, 110, 50);
        doc.text(`Método de pago y cuenta: PPD`, 110, 55);
       
        doc.autoTable({
          head: [["Articulo", "Cantidad", "Precio", "Descuento", "Total"]],
          body: dataPDFLimpia,
          startY: 60,
          foot: [
            [
              "Total prendas",
              new Intl.NumberFormat("en-US").format(
                dataFinal.reduce((t, x) => t + (parseFloat(x.cantidad) || 0), 0)
              ),
              "",
              "Sub Total",
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotal),
            ],
            [
              "",
              "",
              "",
              "IVA",
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(iva),
            ],
            ...(seguro
              ? [[
                  "",
                  "",
                  "",
                  `Seguro mercancía${porcSeguro ? " " + porcSeguro + "%" : ""}`,
                  new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(seguro),
                ]]
              : []),
            ...(pagoTarjeta === "Si" && comisionTarjeta
              ? [[
                  "",
                  "",
                  "",
                  "Cargo tarjeta 3.5%",
                  new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(comisionTarjeta),
                ]]
              : []),
            [
              "",
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total_general),
            ],
          ],
          showFoot: "lastPage",
        });

        // ===== Sección de Devoluciones (parseadas de observaciones) =====
        // Formato guardado por VentaDirecta:
        // "DEV <codigo> <color>/<talla> x<cant> $<precio> (venta <N°> <fecha>)"
        const devRegex =
          /DEV\s+(\S+)\s+(.+?)\/(.+?)\s+x(\d+(?:\.\d+)?)\s+\$(\d+(?:\.\d+)?)\s+\(venta\s+(.+?)\s+(\d{4}-\d{2}-\d{2})\)/g;
        const devRows = [];
        let devTotal = 0;
        let mDev;
        while ((mDev = devRegex.exec(observaciones || "")) !== null) {
          const cant = parseFloat(mDev[4]);
          const prec = parseFloat(mDev[5]);
          const importe = cant * prec;
          devTotal += importe;
          devRows.push([
            mDev[1],
            mDev[2],
            mDev[3],
            mDev[4],
            new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(prec),
            mDev[6],
            mDev[7],
            "-" + new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(importe),
          ]);
        }
        // Devoluciones también sin desglose de color/talla: un renglón por artículo/precio/venta
        const devAgr = new Map();
        devRows.forEach((r) => {
          const k = `${r[0]}|${r[4]}|${r[5]}|${r[6]}`;
          const g = devAgr.get(k) || { art: r[0], cant: 0, precio: r[4], venta: r[5], fecha: r[6], importe: 0 };
          g.cant += parseFloat(r[3]) || 0;
          g.importe += parseFloat(String(r[7]).replace(/[^0-9.]/g, "")) || 0;
          devAgr.set(k, g);
        });
        const devRowsArt = [...devAgr.values()].map((g) => [
          g.art,
          String(g.cant),
          g.precio,
          g.venta,
          g.fecha,
          "-" + new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(g.importe),
        ]);
        if (devRows.length) {
          doc.setFontSize(11);
          doc.setFont(undefined, "bold");
          doc.text("Devoluciones", 10, doc.autoTable.previous.finalY + 10);
          doc.setFont(undefined, "normal");
          doc.autoTable({
            head: [["Articulo", "Cantidad", "Precio", "N° Venta", "Fecha", "Importe"]],
            body: devRowsArt,
            startY: doc.autoTable.previous.finalY + 13,
            headStyles: { fillColor: [220, 53, 69] },
            foot: [
              ["", "", "", "", "Total Devoluciones",
                "-" + new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(devTotal)],
            ],
            showFoot: "lastPage",
          });
        }

        // Observaciones sin las notas de devolución (ya salen en su sección)
        const obsLimpia = (observaciones || "")
          .split(" | ")
          .filter((s) => !s.trim().startsWith("DEV "))
          .join(" | ");

        doc.setFontSize(10);
        var lines = doc.splitTextToSize(`Observaciones ${obsLimpia}`, 200);
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        // Si la venta no está facturada: recuadro "Mercancía pendiente de facturar"
        let yPie = doc.autoTable.previous.finalY + 10 + lines.length * 5;
        if (pendienteDeFacturar(numeroFactura)) {
          yPie = agregarAvisoPendienteFacturar(doc, yPie, numero, esCopia);
          // Firma de confirmación del pedido (en el original con pagaré ya firma el pagaré)
          if (esCopia || formato !== "pagare") yPie = firmaConfirmacionPedido(doc, yPie);
        }
        // Pie según el formato elegido: política de cambios o pagaré (sin devoluciones)
        agregarPieNota(doc, formato, yPie, {
          numero,
          fecha,
          total: total_general,
          plazo,
          cliente: clientes,
          domicilio,
        }, esCopia);
        };
        dibujar(false);
        doc.addPage();
        dibujar(true);

        // Se muestra en la pestaña que se abrió al principio (para que el navegador no la bloquee)
        abrirPDF(doc, ventana);
      })
      .catch((err) => {
        if (ventana && !ventana.closed) ventana.close();
        console.log(err);
      });
  }
  

  // async function Utilidad(
  //   fecha,
  //   idClientes,
  //   clientes,
  //   observaciones,
  //   numero,
  //   idPDFOC,
  //   user,
  //   pedidos,
  //   impuestos,
  //   subTotal,
  //   iva,
  //   total_general,
  //   plazo
  // ) {
  //   let totalCosto = 0;
  //   let totalVenta = 0;
  //   let totalUtilidad = 0;
  //   await axios
  //     .get(`${URL_INVENTARIOS}/surtidos/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosSurtido = response.data;
  //       let arrayTabla = allArticulosSurtido
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulos: a.articulos[0].codigo + " / " + a.articulos[0].codigoCliente + " " + a.articulos[0].descripcion,
  //             idArticulo: a.articulos[0]._id,
  //             colores: a.colores[0].name,
  //             idColores: a.colores[0]._id,
  //             cantidad: a.cantidad,
  //             precio: parseFloat(a.articulosPedido[0].precio) * a.cantidad,
  //             costo: parseFloat(a.telasOC[0].precio) * a.cantidad,
  //             utilidad: (parseFloat(a.articulosPedido[0].precio) - parseFloat(a.telasOC[0].precio) * a.cantidad) ,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //         let agrupado = arrayTabla.reduce(function (groups, item) {
  //           const val = item["idArticulo"] + item["idColores"]
  //       groups[val] = groups[val] || {
  //         idArticulo: item.idArticulo,
  //         idColores: item.idColores,
  //         costo: 0,
  //         precio: 0,
  //         utilidad: 0,
  //         cantidad: 0
  //       };
  //       groups[val].costo += item.costo;
  //       groups[val].precio += item.precio;
  //       groups[val].utilidad += item.utilidad;
  //       groups[val].cantidad += item.cantidad;
  //       groups[val].articulos = item.articulos;
  //       groups[val].idArticulo = item.idArticulo;
  //       groups[val].colores = item.colores;
  //       groups[val].idColores = item.idColores;
  //       return groups;
  //     },[])
  
  //     // let computedComments= Object.values(agrupado)

  //       let dataFinal = Object.values(agrupado);

  //       let mts = dataFinal.filter((e) => e.unidad == "Metros");
  //       let totalMts = mts.map((c) => parseFloat(c.cantidad));
  //       let TM = totalMts.reduce((t, total, index) => t + total, 0);
  //       setTotalMetrosEdit(TM);
  //       let KG = dataFinal.filter((e) => e.unidad == "Kilos");
  //       let totalKG = KG.map((c) => parseFloat(c.cantidad));
  //       let TK = totalKG.reduce((t, total, index) => t + total, 0);
  //       setTotalKilosEdit(TK);

  //       const data = dataFinal.map((a) => {
  //         totalCosto = totalCosto + a.costo;
  //         totalVenta = totalVenta + a.precio;
  //         return [
  //           a.articulos,
  //           a.colores,
  //           new Intl.NumberFormat("en-US").format(a.cantidad),
  //           new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio),
  //           new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costo),
  //           new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio - a.costo),
  //         ];
  //       });
  //       const dataPDF = Object.values(data);
  //       const dataPDFLimpia = dataPDF.filter(function (el) {
  //         return el != null;
  //       });
  //       const doc = new jsPDF();
  //       var img = new Image();
  //       img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  //       doc.addImage(img, "png", 150, 10, 35, 10);
  //       var img2 = new Image();
  //       img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //       doc.addImage(img2, "png", 80, 10, 30, 12);
        
        
  //       doc.setFontSize(10);
  //       doc.text(`Domicilio: Calle: AV 16 de Septiembre No. 46 Bodega 2E y 2D, Col. Alve Blanco, CP: 53370,`, 20, 25);
  //       doc.text(`Naucalpan de juarez, Estado de México, México`, 20, 30);
  //       doc.setFontSize(10);
        
  //       doc.text(`Cliente ${clientes}`, 15, 40);
  //       doc.text(`Plazo ${plazo} días`, 15, 45);
  //       doc.text(
  //         `Metros ${new Intl.NumberFormat("en-US").format(TM)}`,
  //         15,
  //        50
  //       );

  //       doc.text(`Fecha ${fecha}`, 110, 40);
  //       doc.text(`Nota # ${numero}`, 110, 45);
  //       doc.text(`Forma de pago: Pago en una sola exhibición`, 110, 50);
  //       doc.text(`Método de pago y cuenta: PPD`, 110, 55);
       
  //       doc.autoTable({
  //         head: [
  //           [
  //             "Articulo",
  //             "Color",
  //             "Cantidad",
  //             "Venta",
  //             "Costo",
  //             "Utilidad",
  //           ],
  //         ],
  //         body: dataPDFLimpia,
  //         startY: 60,
  //         foot: [
  //           [
  //             "",
  //             "",
  //             "Totales",
  //             new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalVenta),
  //             new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCosto),
  //             new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalVenta - totalCosto),
  //           ],
  //         ],
  //         showFoot: "lastPage",
  //       });

  //       doc.setFontSize(10);
  //       var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
  //       doc.text(10, doc.autoTable.previous.finalY + 10, lines);

  //       doc.save(`Nota-${numero}.pdf`);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  // async function recibida(id){
  //   await axios
  //         .patch(
  //           `${URL_SURTIDOS}/${id}`,
  //           {
  //             recibida: "Si",
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           }
  //         )
  //         .then(() => {
  //           // toggle();
  //           Swal.fire("Good job!", "Actualizado con exito", "success");
  //           const newComments = comments.map((i) => {
  //             if (id === i._id) {
  //               i.recibida = "Si";
  //             }
  //             return i;
  //           });
  //           setComments(newComments);
  //         })
  //          .catch((error) => {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Oops...",
  //             text: "Something went wrong!",
  //             footer: `${error.response.data}`,
  //           });
  //           console.log(error);
  //         });
  // }
  console.table(comments)

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "No. Factura", field: "numeroFactura", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "IVA", field: "iva", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroFactura.toLowerCase().includes(search.toLowerCase()) ||
          // comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.iva.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "total_general" &&
      sorting.field != "subTotal" &&
      sorting.field != "iva"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_general" ||
        sorting.field == "subTotal" ||
        sorting.field == "iva")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_general" ||
        sorting.field == "subTotal" ||
        sorting.field == "iva")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  async function validarSurtido(id){
    await axios
          .patch(
            `${URL_SURTIDOS}/${id}`,
            {
              recibida: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // toggle();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.recibida = "Si";
              }
              return i;
            });
            setComments(newComments);
          })
           .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });

  }

  let totalImporteTabla = 0;
  let subTotalTabla = 0;
  let totalIVATabla = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_admin ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-file-invoice-dollar" style={{ marginRight: 8, color: "#10b981" }} />
                Ventas
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active == "No"){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c"}}>
                      <td>{a.numero}</td>
                      <td>{celdaFactura(a.numeroFactura)}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.is_active == "Si" ? (
                        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)
                          ) : undefined}
                      </td>
                      <td>CANCELADA</td>
                      <td></td>
                      <td></td>
                    </tr>
                  );
                }else{
                  totalImporteTabla = totalImporteTabla + a.total_general;
                  subTotalTabla = subTotalTabla + a.subTotal;
                  totalIVATabla = totalIVATabla + a.iva;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{celdaFactura(a.numeroFactura)}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedor}</td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal)}
                      </td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva)}
                      </td>
                      <td>{ new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general)}
                      </td>
                      <td>
                          <>
                          {a.recibida == "No" ? (
                        <>
                        <Button
                            size="sm"
                            className="btn"
                            color="success"
                            onClick={(e) =>validarSurtido(a._id)}
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                        </>
                      ) : undefined}
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.plazo,
                                  a.numeroFactura,
                                  a.vendedor,
                                  a.seguro,
                                  a.pagoTarjeta,
                                  a.comisionTarjeta,
                                  a.porcSeguro,
                                  a.ivaIncluido
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                              title="Guía de embarque"
                              onClick={() => abrirGuia(a)}
                            >
                              <i className="fas fa-truck"></i>
                            </Button>
                            {parseFloat(a.iva) > 0 ? (
                              <Button
                                size="sm"
                                className="btn"
                                color="success"
                                title={a.numeroFactura && a.numeroFactura !== "No" ? `Factura ${a.numeroFactura} (cambiar)` : "Capturar número de factura"}
                                onClick={() => capturarFactura(a)}
                              >
                                <i className="fas fa-file-invoice-dollar"></i>
                              </Button>
                            ) : undefined}
                            {user.ventas_cancelar ? (
                              <Button hidden={!user.ventas_cancelar}
                                size="sm"
                                className="btn"
                                color="danger"
                                title="Cancelar nota"
                                onClick={(e) => cancelarNota(a._id)}
                              >
                                <i class="fas fa-ban"></i>
                              </Button>
                            ) : undefined}
                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) =>
                                Utilidad(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.plazo
                                )
                              }
                            >
                            <i class="fas fa-chart-line"></i>
                            </Button> */}
                            {/* {a.recibida == "No" ? (
                              <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) => recibida(a._id)}
                            >
                              <i class="far fa-check-circle"></i>
                            </Button>
  
                            ):undefined} */}
                          </>
                      </td>
                    </tr>
                  );
                }

              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVATabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />
      {loader}

      <Modal size="lg" isOpen={modalGuia} toggle={toggleGuia}>
        <ModalHeader toggle={toggleGuia}>
          <i className="fas fa-truck" style={{ marginRight: 8 }} />
          Guía de embarque — Nota #{guia ? guia.numero : ""}
        </ModalHeader>
        <ModalBody>
          {guia && (
            <>
              <Row>
                <Col md={12}>
                  <Label>Nombre</Label>
                  <Input value={guia.nombre} onChange={(e) => setGuia({ ...guia, nombre: e.target.value })} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Label>Sucursal / referencia</Label>
                  <Input
                    placeholder="Ej. A media cuadra del Dr. ..., antes ferretería ..."
                    value={guia.sucursal}
                    onChange={(e) => setGuia({ ...guia, sucursal: e.target.value })}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={8}>
                  <Label>Dirección</Label>
                  <Input value={guia.direccion} onChange={(e) => setGuia({ ...guia, direccion: e.target.value })} />
                </Col>
                <Col md={4}>
                  <Label>Colonia</Label>
                  <Input value={guia.colonia} onChange={(e) => setGuia({ ...guia, colonia: e.target.value })} />
                </Col>
              </Row>
              <Row>
                <Col md={8}>
                  <Label>Población</Label>
                  <Input value={guia.poblacion} onChange={(e) => setGuia({ ...guia, poblacion: e.target.value })} />
                </Col>
                <Col md={4}>
                  <Label>Teléfono</Label>
                  <Input value={guia.telefono} onChange={(e) => setGuia({ ...guia, telefono: e.target.value })} />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label>Transporte</Label>
                  <Input
                    placeholder="Paquetería / transporte"
                    value={guia.transporte}
                    onChange={(e) => setGuia({ ...guia, transporte: e.target.value })}
                  />
                </Col>
                <Col md={4}>
                  <Label>Contenido</Label>
                  <Input value={guia.contenido} onChange={(e) => setGuia({ ...guia, contenido: e.target.value })} />
                </Col>
                <Col md={2}>
                  <Label>Valor</Label>
                  <Input
                    type="number"
                    value={guia.valor}
                    onChange={(e) => setGuia({ ...guia, valor: e.target.value })}
                  />
                </Col>
                <Col md={2}>
                  <Label>Paquetes</Label>
                  <Input
                    type="number"
                    min="1"
                    value={guia.paquetes}
                    onChange={(e) => setGuia({ ...guia, paquetes: e.target.value })}
                  />
                </Col>
              </Row>
              <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: 8 }}>
                Se imprime una hoja por paquete (1/N, 2/N…). Los datos vienen del cliente y se
                pueden corregir aquí sin cambiar el catálogo.
              </p>
              <div className="submit-bar">
                <Button color="secondary" type="button" onClick={toggleGuia}>
                  Cancelar
                </Button>
                <Button color="success" type="button" onClick={generarGuia}>
                  <i className="fas fa-print" style={{ marginRight: 6 }} /> Generar guía
                </Button>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoVentas;
